import React from 'react';
import { Flex, FormControl, FormLabel, Select } from '@chakra-ui/react';
import { Controller } from 'react-hook-form';
import { CustomTextarea, InputText } from '../Input';
import LanguageField from './LanguageField';

const CompanyFields = ({ index, control, disabled }) => {
  return (
    <>
      <Flex gap='16px' align='center'>
        <Controller
          render={({ field }) => (
            <InputText
              {...field}
              label='Razão Social'
              placeholder='Digite aqui a razão social'
              disabled={disabled}
            />
          )}
          name={`form.${index}.name`}
          control={control}
        />

        <Controller
          render={({ field }) => (
            <InputText
              {...field}
              label='Nome Fantasia'
              placeholder='Digite aqui o nome fantasia'
              disabled={disabled}
            />
          )}
          name={`form.${index}.fantasyname`}
          control={control}
        />
      </Flex>

      <Flex gap='16px' align='center'>
        <Controller
          render={({ field }) => (
            <InputText
              {...field}
              label='Endereço'
              placeholder='Digite aqui o endereço'
              disabled={disabled}
            />
          )}
          name={`form.${index}.address`}
          control={control}
        />

        <Controller
          render={({ field }) => (
            <InputText
              {...field}
              label='Telefone da empresa'
              placeholder='Digite aqui o telefone'
              disabled={disabled}
            />
          )}
          name={`form.${index}.phone`}
          control={control}
        />
      </Flex>

      <LanguageField index={index} control={control} disabled={disabled} />

      <Flex>
        <Controller
          render={({ field }) => (
            <CustomTextarea
              {...field}
              label='Lista de CNAES'
              placeholder='Os códigos (CNAE) são adicionados automaticamente após a adição do CNPJ.'
              height='118px'
              disabled={disabled}
            />
          )}
          name={`form.${index}.cnae_list`}
          control={control}
        />
      </Flex>
    </>
  );
};

export default CompanyFields;
